import './index.css';
import { Link } from 'react-router-dom';
import ServicesSubMenu from '../ServicesSubMenu';
import ServicesPricingCTA from '../ServicesPricingCTA';
import nfcCardImage from '../../assets/images/marketing_nfc_card1.png';
import nfcTagBareImage from '../../assets/images/nfc_tag_bare.png';
import nfcTagKeychainImage from '../../assets/images/nfc_tag_with_keychain.png';
import nfcDogImage from '../../assets/images/nfc_dog.png';

const destinations = [
  { title: 'Save Your Contact', description: 'Open a vCard that customers can add directly to their phone.' },
  { title: 'Visit Your Website', description: 'Send people to your home page, service page, menu, portfolio, or online profile.' },
  { title: 'Connect on Social', description: 'Open Facebook, Instagram, or another social destination you choose.' },
  { title: 'Promote an Event', description: 'Share an event page, registration link, special offer, or campaign destination.' },
];

const ServicesNfcCards = () => (
  <div className="nfc-service-page">
    <ServicesSubMenu />

    <section className="nfc-hero" aria-labelledby="nfc-service-title">
      <div className="nfc-hero-copy">
        <p className="nfc-kicker">Custom NFC Business Cards & Keychains</p>
        <h1 id="nfc-service-title">Share your business with one simple tap.</h1>
        <p>
          Turn an introduction into an instant digital connection. Hogcloud creates
          custom NFC cards and keychains with your logo, colors, and link—ready to
          open your contact card, website, social profile, event, or another destination.
        </p>
        <div className="nfc-hero-actions">
          <Link className="nfc-primary-link" to="/contact">Design My NFC Card</Link>
          <Link className="nfc-secondary-link" to="/services/3dprints">Explore 3D Prints</Link>
        </div>
      </div>
      <div className="nfc-hero-visual" aria-label="Custom Hogcloud NFC business card sharing contact details with a phone">
        <div className="nfc-card-photo"><img src={nfcCardImage} alt="Custom NFC business card and keychain" /></div>
        <div className="nfc-tap-waves" aria-hidden="true"><span /><span /><span /></div>
        <div className="nfc-phone-card">
          <span className="nfc-phone-notch" />
          <small>CONTACT READY</small>
          <strong>Your Business</strong>
          <p>Website · Phone · Social</p>
          <div>Save Contact</div>
        </div>
        <p className="nfc-tap-label">Tap. Open. Connect.</p>
      </div>
    </section>

    <section className="nfc-price-strip" aria-label="NFC card and keychain pricing">
      <article><span>NFC Design FEe</span><strong>$50</strong><small>Your logo, Your design</small></article>
      <article><span>Additional cards</span><strong>$10</strong><small>Get more</small></article>
      <article><span>Keychains</span><strong>$10</strong><small>Your Logo on Keychain</small></article>
      <article><span>Keychains</span><strong>$5</strong><small>Standard NFC Symbol Keychain</small></article>
    
    </section>

    <section className="nfc-section nfc-readymade" aria-labelledby="nfc-readymade-title">
      <div className="nfc-readymade-copy">
        <p className="nfc-kicker">Pre-Made & Ready to Ship</p>
        <h2 id="nfc-readymade-title">Ready 2 Go NFC Tags</h2>
        <p>
          These tags are ready to go and work for all kinds of uses—keep one on a keychain
          to share your social media or Venmo, clip one onto a sports bag or event bag, or
          use one as a dog tag so a scan brings up a quick phone call or contact info for a
          missing pet.
        </p>
        <Link className="nfc-readymade-price" to="/contact#contact">$6 each</Link>
      </div>
      <div className="nfc-readymade-images">
        <img src={nfcTagBareImage} alt="Bare Ready 2 Go NFC tag" />
        <img src={nfcTagKeychainImage} alt="Ready 2 Go NFC tag on a keychain" />
        <img src={nfcDogImage} alt="Ready 2 Go NFC tag used as a pet dog tag" />
      </div>
    </section>

    <section className="nfc-section nfc-benefits" aria-labelledby="nfc-benefits-title">
      <div>
        <p className="nfc-kicker">Why Go Tap-to-Share?</p>
        <h2 id="nfc-benefits-title">A business card people can use immediately.</h2>
      </div>
      <div className="nfc-benefit-grid">
        <article><strong>No app required</strong><p>A compatible phone reads the NFC chip and offers to open your programmed destination.</p></article>
        <article><strong>No battery required</strong><p>The phone briefly energizes the passive chip and antenna when it is held nearby.</p></article>
        <article><strong>Less paper to carry</strong><p>Share the same business information again and again from one memorable branded item.</p></article>
        <article><strong>Made for your brand</strong><p>Customize the logo, colors, format, and appropriate size for your business card or keychain.</p></article>
      </div>
    </section>

    <section className="nfc-section" aria-labelledby="nfc-destinations-title">
      <p className="nfc-kicker">One Tap, Your Destination</p>
      <h2 id="nfc-destinations-title">Choose what customers see next.</h2>
      <div className="nfc-destination-grid">
        {destinations.map((destination, index) => (
          <article key={destination.title}>
            <span>0{index + 1}</span><h3>{destination.title}</h3><p>{destination.description}</p>
          </article>
        ))}
      </div>
    </section>

    <section className="nfc-section nfc-how" aria-labelledby="nfc-how-title">
      <div>
        <p className="nfc-kicker">How NFC Works</p>
        <h2 id="nfc-how-title">Wireless sharing at very close range.</h2>
      </div>
      <p>
        NFC means Near Field Communication. A small passive chip and antenna sit inside
        the item. When a compatible phone is held close, the phone energizes the chip and
        receives the programmed destination. Although people sometimes search for “RFID
        business cards,” NFC is the close-range tap technology used for this experience.
      </p>
    </section>

    <section className="nfc-cta" aria-labelledby="nfc-cta-title">
      <div><p className="nfc-kicker">Make the Next Introduction Count</p><h2 id="nfc-cta-title">Bring your logo. We’ll build the tap.</h2></div>
      <Link className="nfc-primary-link" to="/contact">Request an NFC Card</Link>
    </section>

    <ServicesPricingCTA />
  </div>
);

export default ServicesNfcCards;
